export default __webpack_public_path__ + "static/media/fleet_transporters.a6b2b4d5.png";